/**
 * Fraction of the map viewport (width and height) treated as the "comfort zone"
 * for hover. When the listing is outside this zone, the map recenters before
 * or while revealing the price pill. 1/3 = centre third; 1 = never recenter.
 */
export const MAP_HOVER_RECENTER_VIEWPORT_FRACTION = 1 / 3;
